<template>
  <div v-if="assignment && assignment.content" class="wrapper">
    <vueEmbedComponent
      :id="assignment.content"
      @close="closeAssignment"
      :namespace="route.params.id"
      :environmentProxy="addVariables"
      allow="camera;microphone;fullscreen"
    />
  </div>
  <div v-else-if="assignment" class="wrapper message">
    {{ t('there-is-an-issue-with-your-assignment-please-as') }}
  </div>
  <div v-else class="wrapper message">
    ... {{ t('loading') }} ...
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { vueEmbedComponent } from '@knowlearning/agents/vue.js'
import studyEnvironmentVariableProxy from '../../study-environment-variable-proxy.js'

const route = useRoute()
const store = useStore()

const { id } = route.params
const assignment = ref(await Agent.state(id))
const { owner: teacher } = await Agent.metadata(id)

const closeAssignment = () => Agent.close()

const addVariables = await studyEnvironmentVariableProxy({}, teacher)

function t(slug) {
  return store.getters.t(slug)
}

</script>

<style scoped>
.wrapper {
  position: absolute;
  background: white;
  width: 100vw;
  height: calc(var(--vh, 1vh) * 100);
  top: 0;
  left: 0;
}

.message {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 24px;
  box-sizing: border-box;
}
</style>
